export function deepEqual(a, b, ignoredKeys = new Set()) {
  if (a === b) return true

  if (
    typeof a !== 'object' || a === null
    || typeof b !== 'object' || b === null
  ) {
    return false
  }

  const keysA = Object.keys(a)
    .filter(k => !ignoredKeys.has(k))

  const keysB = Object.keys(b)
    .filter(k => !ignoredKeys.has(k))

  if (keysA.length !== keysB.length) {
    return false
  }

  for (const key of keysA) {
    if (!keysB.includes(key)) {
      return false
    }

    if (!deepEqual(a[key], b[key], ignoredKeys)) {
      return false
    }
  }
  return true
}
